const callsQueryKeys = {
  all: ['calls'] as const,
  parked: (skip: number, take: number, sortBy: any, filters: any) =>
    [...callsQueryKeys.all, 'parked', skip, take, sortBy, filters] as const,
};

export default callsQueryKeys;
